import { QuestionnaireResponse } from 'modules/questionnaires/components/QuestionnaireResponse'
import { QuestionnaireResponseContent } from 'modules/questionnaires/lib/types'

type Props = { currentPreview: QuestionnaireResponseContent }
export const PublishedQuestions = ({ currentPreview }: Props) => {
  return <QuestionnaireResponse readonly content={currentPreview} onAnswer={() => ({})} />
}
